import type { Maybe } from "@/components/utils/typeHelpers";
import type { IPadding } from "@tp/tpcontrols/paddings";

const fromPadding = (padding: IPadding | null) => {
  return padding
    ? "padding: " +
        padding.top +
        "px " +
        padding.right +
        "px " +
        padding.bottom +
        "px " +
        padding.left +
        "px; "
    : "";
};

const styleFormat = {
  fromPadding,
  fromBackColour: (backColour: string | null) =>
    backColour ? "background-color: " + backColour + "; " : "",
  fromMaxWidth: (maxWidth: Maybe<number>) =>
    maxWidth ? " max-width:" + maxWidth + "px; " : "",
  fromColour: (colour: string | null) =>
    colour ? "color: " + colour + "; " : "",
};

export { styleFormat };
